import { NgModule } from '@angular/core';
;
import { ScriptingEditorComponent } from './scripting-editor.component';
import { ScriptingEditorService } from './scripting-editor.service';
import { CxFormsModule } from '@forms';
import { CommonModule } from '@angular/common';
import { LoaderModule } from '@loader';
import { AddWhileLoopSnippet } from './code-snippets/add-while-loop.snippet';
import { AddDatapointSnippet } from './code-snippets/add-datapoint.snippet';
import { UiDialogModule } from '@ui-dialog';
import { AddMainLoopSnippet } from './code-snippets/add-main-loop.snippet';
import { AddSystemMainLoopSnippet } from './code-snippets/add-main-system-loop.snippet';
import { AddAlarmMainLoopSnippet } from './code-snippets/add-main-alarm-loop.snippet';
import { ProcessAlarmsSnippet } from './code-snippets/process-alarms.snippet';
import { ReadDatapointSnippet } from './code-snippets/read-datapoint.snippet';
import { WriteDatapointSnippet } from './code-snippets/write-datapoint.snippet';
import { AddForLoopSnippet } from './code-snippets/add-for-loop.snippet';
import { IfElseStatementpSnippet } from './code-snippets/if-else-statement.snippet';
import { IfElseIfStatementpSnippet } from './code-snippets/if-else-if-else-statement.snippet';
import { ShowSnippet } from './code-snippets/show.snippet';
import { UiFormatModule } from '@ui-format';
import { FormsModule } from '@angular/forms';
import { UiButtonsModule } from '@ui-buttons';
import { FilterByScriptModePipe } from './filter-by-scriptmode.pipe';
import { FilterByCategoryPipe } from './filter-by-category.pipe';
import { AddRootCausesSnippet } from './code-snippets/add-root-cause.snippet';
import { AddAlarmTypesSnippet } from './code-snippets/add-alarm-type.snippet';
import { ActOnPlantSnippet } from './code-snippets/act-on-plant.snippet';
import { AddUntilLoopSnippet } from './code-snippets/add-until-loop.snippet';

import { ReadAndWriteDatapointExampleOOP } from './code-examples/read-and-write-datapoint.oop.example';
import { ReadAndWriteDatapointExampleSystem } from './code-examples/read-and-write-datapoint.example.system';
import { ReadAndWriteDatapointExampleAlarm } from './code-examples/process-alarms.example';
import { NorthboundApiExampleDPHistory } from './code-examples/call-northbound-api.example';
import { CallNBApi } from './code-snippets/call.nb.api';
import { EquivalenciesExample } from './code-examples/read-and-write-datapoint.equivalencies.example';
import { IterateArraySnippet } from './code-snippets/iterate.array.snippet';
import { IterateObjectSnippet } from './code-snippets/iterate.object.snippet';
import { ShowFrmtSnippet } from './code-snippets/show.frmt.snippet';
import { CustomFunctionExample } from './code-examples/functions.example';
import { MiscFunctionExample } from './code-examples/misc-functions.example';
import { UiMessagesModule } from '../ui-messages-module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        CxFormsModule,
        LoaderModule,
        UiDialogModule,
        UiFormatModule,
        UiButtonsModule,
        UiMessagesModule
    ],
    declarations: [
        ScriptingEditorComponent,
        AddDatapointSnippet,
        AddWhileLoopSnippet,
        AddMainLoopSnippet,
        AddSystemMainLoopSnippet,
        AddAlarmMainLoopSnippet,
        ReadDatapointSnippet,
        WriteDatapointSnippet,
        AddForLoopSnippet,
        IfElseStatementpSnippet,
        IfElseIfStatementpSnippet,
        ShowSnippet,
        FilterByScriptModePipe,
        FilterByCategoryPipe,
        AddRootCausesSnippet,
        AddAlarmTypesSnippet,
        ProcessAlarmsSnippet,
        ActOnPlantSnippet,
        AddUntilLoopSnippet,
        ReadAndWriteDatapointExampleOOP,
        ReadAndWriteDatapointExampleSystem,
        ReadAndWriteDatapointExampleAlarm,
        NorthboundApiExampleDPHistory,
        CallNBApi,
        EquivalenciesExample,
        IterateArraySnippet,
        IterateObjectSnippet,
        ShowFrmtSnippet,
        CustomFunctionExample,
        MiscFunctionExample
    ],
    exports: [
        ScriptingEditorComponent,
        AddDatapointSnippet,
        AddWhileLoopSnippet,
        AddMainLoopSnippet,
        AddSystemMainLoopSnippet,
        AddAlarmMainLoopSnippet,
        ReadDatapointSnippet,
        WriteDatapointSnippet,
        AddForLoopSnippet,
        ShowSnippet,
        AddRootCausesSnippet,
        AddAlarmTypesSnippet,
        ProcessAlarmsSnippet,
        ActOnPlantSnippet,
        AddUntilLoopSnippet,
        ReadAndWriteDatapointExampleOOP,
        ReadAndWriteDatapointExampleSystem,
        ReadAndWriteDatapointExampleAlarm,
        NorthboundApiExampleDPHistory,
        CallNBApi,
        EquivalenciesExample,
        IterateArraySnippet,
        IterateObjectSnippet,
        ShowFrmtSnippet,
        CustomFunctionExample,
        MiscFunctionExample
    ],
    providers : [
        ScriptingEditorService
    ]
})
export class ScriptingEditorModule {}

export { 
    ScriptingEditorService,
    ScriptingEditorComponent
}
